import brandPage from './brandPage/rest'
import fragranceOfTheMonthPage from './fragranceOfTheMonthPage/rest'


export default {
  brandPage,
  fragranceOfTheMonthPage,
}
